import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";

function Home(){
    const [posts , setpost] = useState([])
    const img = "https://webeetec.com/itsharks24/blog/admin/"
    useEffect(()=>{
        fetch("https://webeetec.com/itsharks24/blog/api/getposts.php")
        .then(r=>r.json())
        .then((r)=>{
            console.log(r);
            setpost(r);
        }
        )
    }, [])
    return(
        <div>
            <section className="container mt-5">
		<div className="wrapper clear">
			
			<div className="clear"></div>
			<div className="contentLeft">
				<div className="blogPostListWrap">
                    {
                        posts.map((post)=>{
                            return(
                                <div className="blogPostListItem clear">
                                    <a href="single.html" className="blogPostListImg">
                                        <img src={ img + post.image} alt="Francoise img"/>
                                    </a>
                                    <div className="blogPostListText">
                                        <div className="blogPostListTime">{post.date}</div>
                                        <h3><Link to={"single/" + post.id}>{post.title} </Link></h3>
                                        <p>{post.description}</p>
                                    </div>
					            </div>
                            )
                        })
                    }
					
					
				</div>
				<div className="postPagination">
					<ul className="clear">
						<li className="newPosts"><a href="#">New posts</a></li>
						<li className="olderPosts"><a href="#">Older posts</a></li>
					</ul>
				</div>
			</div>
			<Sidebar/>
		</div>
		<div className="clear"></div>
		
	</section>
        </div>
    )
}
export default Home;